module.exports = __webpack_public_path__ + "img/img01.9007a38c.png";